export default __webpack_public_path__ + "static/media/m_engineering_card21_1.852fab06.png";